// import { AppUserProfile } from "../container-components/wallet-application-wrapper";
import IconArbitrum from "./../assets/img/Group 287.svg";
import IconBsc from "./../assets/img/Group 288.svg";
import {
  APELPCFRMBNBTokenContractAddress,
  APELPCFRMxBNBTokenContractAddress,
  arbitrumTestTokenContractAddress,
  cFRMTokenContractAddress,
  cFRMxTokenContractAddress,
  tokenArbTestFrmMainnet,
  tokenFRMBSCMainnet,
  tokenFRMxBSCMainnet,
} from "./const.utils";

export const BRIDGE_NETWORKS = [
  "ETHEREUM",
  "RINKEBY",
  "RINKEBY",
  "BSC",
  "BSC_TESTNET",
  "POLYGON",
  "MUMBAI_TESTNET",
  "AVAX_TESTNET",
  "AVAX_MAINNET",
  "MOON_MOONRIVER",
  "HARMONY_TESTNET_0",
  "FTM_TESTNET",
  "FTM_MAINNET",
];

export const BRIDGE_CONTRACTS = {
  RINKEBY: "0x89262b7bd8244b01fbce9e1610bf1d9f5d97c877",
  BSC_TESTNET: "0x89262b7bd8244b01fbce9e1610bf1d9f5d97c877",
  MUMBAI_TESTNET: "0x89262b7bd8244b01fbce9e1610bf1d9f5d97c877",
  ETHEREUM: "0x8e01cc26d6dd73581347c4370573ce9e59e74802",
  BSC: "0x8e01cc26d6dd73581347c4370573ce9e59e74802",
  POLYGON: "0x8e01cc26d6dd73581347c4370573ce9e59e74802",
  AVAX_TESTNET: "0xbe442727d882b17144040a075acf27abbb68643f",
  MOON_MOONBASE: "0x347d11cc7fbeb535d71e1c6b34bdd33a7a999f45",
  AVAX_MAINNET: "0x8e01cc26d6dd73581347c4370573ce9e59e74802",
  MOON_MOONRIVER: "0x8e01cc26d6dd73581347c4370573ce9e59e74802",
  HARMONY_TESTNET_0: "0x1be6148e383abee84d68d3c6a9fc61809b16a6a4",
  HARMONY_MAINNET_0: "0x8e01cc26d6dd73581347c4370573ce9e59e74802",
  FTM_TESTNET: "0x769a03c4080c090d6e4e751d1e362d889c4d8bec",
  FTM_MAINNET: "0x8e01cc26d6dd73581347c4370573ce9e59e74802",
} as any;

const chainContent = (
  chainId: string,
  chainName: string,
  name: string,
  symbol: string,
  decimals: number,
  rpcUrls: string[],
  blockExplorerUrls: string[]
) => ({
  chainId: chainId,
  chainName: chainName,
  nativeCurrency: {
    name: name,
    symbol: symbol,
    decimals: decimals,
  },
  rpcUrls: rpcUrls,
  blockExplorerUrls: blockExplorerUrls,
});

export const chainData = {
  ETHEREUM: chainContent(
    "0x1",
    "Ethereum Mainnet",
    "ETH",
    "ETH",
    1,
    ["https://mainnet.infura.io/v3/"],
    ["https://etherscan.io/"]
  ),
  RINKEBY: chainContent(
    "0x4",
    "Rinkeby Test Network",
    "ETH",
    "ETH",
    4,
    ["https://rinkeby.infura.io/v3/"],
    ["https://rinkeby.etherscan.io/"]
  ),
  BSC_TESTNET: chainContent(
    "0x61",
    "BSC Testnet",
    "BNB",
    "BNB",
    18,
    ["https://data-seed-prebsc-1-s1.binance.org:8545/"],
    ["https://explorer.binance.org/smart-testnet/"]
  ),
  BSC: chainContent(
    "0x38",
    "Binance Smart Chain",
    "BNB",
    "BNB",
    18,
    ["https://bsc-dataseed.binance.org/"],
    ["https://bscscan.com/"]
  ),
  POLYGON: chainContent(
    "0x89",
    "Polygon (Matic)",
    "MATIC",
    "MATIC",
    18,
    ["https://rpc-mainnet.maticvigil.com/"],
    ["https://ploygonscan.com/"]
  ),
  MUMBAI_TESTNET: chainContent(
    "0x13881",
    "Matic (Mumbai) testnet",
    "MATIC",
    "MATIC",
    18,
    ["https://rpc-mumbai.maticvigil.com/"],
    ["https://mumbai.polygonscan.com/"]
  ),
  SOLANA: chainContent(
    "0x38",
    "Binance Smart Chain",
    "BNB",
    "BNB",
    18,
    ["https://bsc-dataseed.binance.org/"],
    ["https://bscscan.com/"]
  ),
  ARBITRUM: chainContent(
    "0xA4B1",
    "Arbitrum One",
    "ETH",
    "ETH",
    18,
    ["https://nd-113-386-204.p2pify.com/05011fd3704fffb222caf614adeb5e35"],
    ["https://arbiscan.io"]
  ),
};

export const tokenSymbols = {
  LEO: "https://gateway-revamp.s3.us-east-2.amazonaws.com/side-menu/Leo.svg",
  cLEO: "https://gateway-revamp.s3.us-east-2.amazonaws.com/side-menu/cLEO.svg",
};

export type TokenSymbolIndex = keyof typeof tokenSymbols;

// export const tokensList = [
//   {
//     token: "cFRM",
//     currency: cFRMTokenContractAddress,
//     network: "BSC",
//   },
//   {
//     token: "cFRMx",
//     currency: cFRMxTokenContractAddress,
//     network: "BSC",
//   },
//   {
//     token: "APELPCFRMBNB",
//     currency: APELPCFRMBNBTokenContractAddress,
//     network: "BSC",
//   },
//   {
//     token: "APELPCFRMxBNB",
//     currency: APELPCFRMxBNBTokenContractAddress,
//     network: "BSC",
//   },
//   {
//     token: "FRMBSC",
//     currency: tokenFRMBSCMainnet,
//     network: "BSC",
//   },
//   {
//     token: "FRMxBSC",
//     currency: tokenFRMxBSCMainnet,
//     network: "BSC",
//   },
//   {
//     token: "cTestFrm",
//     currency: arbitrumTestTokenContractAddress,
//     network: "ARBITRUM",
//   },
//   {
//     token: "testFrm",
//     currency: tokenArbTestFrmMainnet,
//     network: "ARBITRUM",
//   },
//   {
//     token: "LEO",
//     currency: "0x56B331c7E3D68306f26e07492125F0FAa9d95343",
//     network: "LEO",
//   },
// ];

export const networkLogoMap: { [key: string]: any } = {
  ARBITRUM: IconArbitrum,
  BSC: IconBsc,
};

// export function addressForUser(user?: AppUserProfile) {
//   if (!user) {
//     return undefined;
//   }
//   return (user.accountGroups || [])[0].addresses[0] || {};
// }

// export function logError(msg: string, err: Error) {
//   console.error(msg, err);
// }
export const MY_TRADES_HEADER = [
  { title: "FROM", prop: "from" },
  { title: "TO", prop: "to" },
  { title: "DATE UTC", prop: "dateUTC" },
  { title: "FROM HASH", prop: "fromHash" },
  { title: "TO HASH", prop: "toHash" },
  { title: "PROVIDER", prop: "provider" },
  { title: "STATUS", prop: "status" },
  { title: "", prop: "details" },
];

export const SwapAndWithdrawTxStatuses: { [key: string]: string } = {
  generatorSignatureCreated: "Generator Signature Created",
  generatorSignatureFailed: "Swap failed!",
  validatorSignatureCreated: "Validator Signature Created",
  validatorSignatureFailed: "Swap failed!",
  masterValidationFailed: "Swap failed!",
  swapPending: "Swap Pending",
  swapCreated: "Swap Created",
  swapCompleted: "Swap Completed",
  swapFailed: "Swap failed! Please try again.",
  swapWithdrawGenerated: "Swap Withdraw Generated",
  swapWithdrawPending: "Swap Withdraw Pending",
  swapWithdrawFailed: "Swap Withdraw Failed",
  swapWithdrawCompleted: "Swap Withdraw Completed",
};

export const ProviderAssetsLogo: { [key: string]: string } = {
  Foundary: "https://etherscan.io/token/images/ferrumnetwork_32.png?=v454",
  "1Inch": "https://etherscan.io/token/images/1inch_32.png?=v454",
};

export const truncateText = (
  str: string,
  length: number,
  position?: string
) => {
  if (str.length > 20) {
    return position === "center"
      ? str.substr(0, length) +
          "....." +
          str.substr(str.length - length, str.length)
      : position === "start"
      ? "....." + str.substr(0, length)
      : str.substr(0, length) + ".....";
  }
  return str;
};
